import {Component, Input, OnInit} from '@angular/core';
import {SitePageChartDataModel} from '../../../models/SitePageChartDataModel';

@Component({
    selector: 'app-page-review-scores-chart',
    templateUrl: './page-review-scores-chart.component.html',
    styleUrls: ['./page-review-scores-chart.component.css']
})
export class PageReviewScoresChartComponent implements OnInit {

    @Input()
    pageChartData: SitePageChartDataModel;
    chart;
    chartOptions = {};

    constructor() {}

    ngOnInit(): void {
        this.chartOptions = {
            title: {text: this.createChartTitle(this.pageChartData.averageScoreAccumulatorAlias)},
            xAxis: {
                type: 'datetime',
                labels: {
                    format: '{value:%Y-%m-%e}'
                },
                title: {
                    text: 'Date'
                }
            },
            yAxis: {
                title: {
                    text: 'Score'
                },
                min: 0,
                max: 100
            },
            series: [{
                data: this.convertChartDataToArrays(this.pageChartData.data),
            }]
        };
    }

    private convertChartDataToArrays(chartData): Array<Array<string>> {
        return Object.keys(chartData).map((key) => {
            return [Date.parse(key), chartData[key]];
        });
    }

    onChartLoad(chartInstance) {
        this.chart = chartInstance;
    }

    private createChartTitle(scoreAccumulatorAlias: string) {
        return 'Average ' + scoreAccumulatorAlias + ' scores';
    }
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/page/page-review-scores-chart/page-review-scores-chart.component.ts